/* ══════════════════════════════════════════════════════════════════════
   Splash — Ripple integration seam  ***STUB***

   The Ripple chat surface does not exist in this theme yet. This module is
   the single seam every other component talks to, so wiring the real
   surface later is a one-file change and no component has to be touched.

   Public API
     Splash.Ripple.open({ source })      open the chat surface
     Splash.Ripple.query(text, { source })  send a question
     Splash.Ripple.setThinking(bool)     drive the mark's thinking state
     Splash.Ripple.register(impl)        mount the real surface
     Splash.Ripple.isMounted()           has a real surface been mounted?

   Two ways to mount the real thing:
     1. Splash.Ripple.register({ open: fn, query: fn })
     2. Listen for the 'splash:ripple:open' / 'splash:ripple:query' events
        on `document` and call preventDefault() to claim them.

   Until then the stub logs the intent and runs the mark's thinking state
   for one loop so the wiring is observable. Nothing here fabricates an
   answer.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var Splash = (window.Splash = window.Splash || {});

  var surface = null;
  var thinkingTimer = null;
  var STUB_THINKING_MS = 2400; /* one loop of the 2.4s echo */

  function emit(name, detail) {
    var event = new CustomEvent(name, {
      detail: detail || {},
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
    /* A listener that calls preventDefault() has claimed the intent. */
    return event.defaultPrevented;
  }

  function stubNotice(what, detail) {
    if (window.console && console.info) {
      console.info(
        '[Splash] Ripple ' +
          what +
          ' — no chat surface mounted yet. ' +
          'Call Splash.Ripple.register({ open, query }) or handle the ' +
          "'splash:ripple:" +
          what +
          "' event to take over.",
        detail || {}
      );
    }
  }

  var Ripple = {
    isMounted: function () {
      return surface !== null;
    },

    register: function (impl) {
      surface = impl || null;
      document.dispatchEvent(new CustomEvent('splash:ripple:ready'));
    },

    /* Opens the full Ripple chat surface. */
    open: function (options) {
      var detail = options || {};
      if (surface && typeof surface.open === 'function') {
        return surface.open(detail);
      }
      if (emit('splash:ripple:open', detail)) return;
      stubNotice('open', detail);
    },

    /* Submits a question. `text` is the raw user input. */
    query: function (text, options) {
      var value = (text || '').trim();
      if (!value) return;

      var detail = Object.assign({ text: value }, options || {});

      if (surface && typeof surface.query === 'function') {
        return surface.query(value, detail);
      }
      if (emit('splash:ripple:query', detail)) return;

      /* Stub path: show the thinking state so the mark animation and the
         reduced-motion fallback are both exercisable, then stand down. */
      stubNotice('query', detail);
      Ripple.setThinking(true);
      clearTimeout(thinkingTimer);
      thinkingTimer = setTimeout(function () {
        Ripple.setThinking(false);
      }, STUB_THINKING_MS);
    },

    /* Toggles the concentric-ring "thinking" echo on every Ripple mark,
       or on a specific one if an element is passed. */
    setThinking: function (on, root) {
      var scope = root || document;
      var marks = scope.querySelectorAll('[data-ripple-mark]');
      for (var i = 0; i < marks.length; i++) {
        marks[i].setAttribute('data-thinking', on ? 'true' : 'false');
      }
    }
  };

  Splash.Ripple = Ripple;
})();
